import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import {
  Sparkles, FolderOpen, Shield, LogOut, Wand2,
} from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function Layout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const items = [
    { to: "/generator", label: "Generator", icon: Wand2, testid: "nav-generator" },
    { to: "/library", label: "Library", icon: FolderOpen, testid: "nav-library" },
  ];
  if (user?.role === "admin") {
    items.push({ to: "/admin", label: "Admin", icon: Shield, testid: "nav-admin" });
  }

  return (
    <div className="flex h-screen bg-white" data-testid="app-shell">
      {/* Sidebar */}
      <aside className="w-64 border-r border-zinc-200 bg-zinc-50 flex flex-col flex-shrink-0">
        <div className="p-6 border-b border-zinc-200">
          <button
            onClick={() => nav("/generator")}
            className="flex items-center gap-2 text-left"
            data-testid="brand-button"
          >
            <div className="w-8 h-8 bg-[#0055FF] rounded-sm flex items-center justify-center">
              <Sparkles className="w-4 h-4 text-white" strokeWidth={2} />
            </div>
            <div>
              <div className="font-heading font-bold text-zinc-900 text-sm leading-tight">MIG</div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
                Image Generator
              </div>
            </div>
          </button>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-sm text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-zinc-900 text-white"
                      : "text-zinc-700 hover:bg-zinc-100"
                  }`
                }
              >
                <Icon className="w-4 h-4" strokeWidth={1.75} />
                {it.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="p-3 border-t border-zinc-200 space-y-2">
          <div className="px-3 py-2 text-xs">
            <div className="font-medium text-zinc-900 truncate" data-testid="user-email">
              {user?.email}
            </div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mt-0.5">
              {user?.role} · {user?.total_images || 0} imgs · ${(user?.total_cost_usd || 0).toFixed(2)}
            </div>
          </div>
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-sm text-sm text-zinc-600 hover:bg-zinc-100 hover:text-zinc-900 transition-colors"
            data-testid="logout-button"
          >
            <LogOut className="w-4 h-4" strokeWidth={1.75} /> Sign out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
